import { render, staticRenderFns } from "./AverageBasketIndicator.vue?vue&type=template&id=c54c89d0&scoped=true"
import script from "./AverageBasketIndicator.vue?vue&type=script&lang=js"
export * from "./AverageBasketIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54c89d0",
  null
  
)

export default component.exports